// The runtime and the mirror script share these keys.
export function mirrorKey(source) {
  const url = new URL(source);
  return url.host + url.pathname;
}

function toolchainName({ toolchain: { tvm, mlcLlm, emsdkImage } }) {
  const emsdk = emsdkImage.split('@')[0].split(':')[1];
  return `tvm-${tvm.slice(0, 12)}_mlc-llm-${mlcLlm.slice(0, 12)}_emsdk-${emsdk}`;
}

export const libDir = (pins) => `model-libs/${toolchainName(pins)}/`;

export const libKey = (pins, id) => `${libDir(pins)}${id}.wasm`;

// One catalog per toolchain: a bundle only reads models whose libraries it can run.
export const catalogKey = (pins) => `catalog/${toolchainName(pins)}.json`;

export function noticeText(pins, licenseId) {
  return [pins.licenses[licenseId].notice, pins.modificationNote].filter(Boolean).join('\n\n') + '\n';
}
